import { createFileRoute, useParams } from '@tanstack/react-router'
import { FeatureFlagsManagementPage } from '../../../../components/feature-flags/FeatureFlagsManagementPage'

export const Route = createFileRoute('/$org/settings/feature-flags/')({
    component: SettingsFeatureFlagsIndexPage,
})

function SettingsFeatureFlagsIndexPage() {
    const { org } = useParams({ from: '/$org/settings/feature-flags/' })
    return <FeatureFlagsManagementPage org={org} />
}
